import problemsolving from './problemsolving'
import quickaction from './quickaction'
import rev from './rev'
import stream from './stream'
import organization from './organization'
import country from './country'

const api = {
  problemsolving,
  quickaction,
  rev,
  stream,
  organization,
  country,
}

export default api
